import { useState } from "react";
import { Dropdown, Image, Button } from "react-bootstrap";
import DropdownDownIcon from "../icons/DropdownDownIcon";
import { CircleCheckBox } from "../form/CircleCheckBox";
import DropdownUpIcon from "../icons/DropdownUpIcon";
import { useDispatch, useSelector } from "react-redux";
import { notificationFilterConstants } from "../../constants";
import useWorkspaceFilterHook from "../../hooks/useWorkspaceFilterHook";

function SubMenuItem({ 
    item, 
    openId, 
    setOpenId, 
    isSelected,
    handleWorkspaceToggle,
    handleToggleOrg ,
    unselected_workspace_ids
}) {
    const isOpen = openId === item.id;
    const organizationTitle = item?.personal && item?.owner ? "My Workspace" : item?.name;
    const workspace_ids = item?.workspaces?.map(w => w.id) || [];
    const hasUnlselectedWorkspaces = workspace_ids.some(id => unselected_workspace_ids.includes(id));

    const openMenuOrg = () => {
        if (isOpen) {
            setOpenId(null);
        } else {
            setOpenId(item.id);
        }
    }

    return (
        <div className={`submenu-container ${isOpen ? 'open' : ''}`}>
            <div
                className="dropdown-item d-flex align-items-center"
                style={{ cursor: "pointer" }}
                onClick={openMenuOrg}
            >
                    <div
                        onClick={(e) => handleToggleOrg(e, item)}
                    >
                        {
                            hasUnlselectedWorkspaces ? 
                                <CircleCheckBox 
                                    height={18} 
                                    width={18} 
                                    isChecked={false} 
                                    isCustomNotCheckedIcon={true}
                                />
                            :
                                <CircleCheckBox 
                                    height={18} 
                                    width={18} 
                                    isChecked={isSelected(item, 'organization')} 
                                />
                            
                        }

                     
                    </div>

                    <span 
                        className="text-truncate submenu-organization-name"
                    >
                        {organizationTitle}
                    </span>

                {
                    isOpen ? 
                    <DropdownUpIcon height={'8'} width={'8'} className="dropdown-icon"/> :
                    <DropdownDownIcon height={'8'} width={'8'} className="dropdown-icon" color={'#0F172A'}/>
                }
            </div>

            {isOpen && (
                <div className="submenu-items">
                    {
                        item?.workspaces.length > 0 ?
                            item.workspaces.map((workspace, index) => (
                                <Dropdown.Item 
                                    className="d-flex align-items-center" 
                                    key={workspace.id}
                                    onClick={(e) => handleWorkspaceToggle(e, workspace)}
                                >    
                                    <CircleCheckBox height={18} width={18} isChecked={isSelected(workspace, 'workspace')}/>
                                    <span className="text-truncate submenu-workspace-name">{workspace.name}</span>
                                </Dropdown.Item>
                            )) : 
                        (
                            <Dropdown.Item className="text-center">    
                                <span className="text-truncate submenu-workspace-name">No Workspaces</span>
                            </Dropdown.Item>
                        )
                    }
                </div>
            )}
        </div>
    )
}

function NotificationWorkspaceDropdown() {
    const [openId, setOpenId] = useState(null);
    const dispatch = useDispatch();

    // Hooks
    useWorkspaceFilterHook();

    // Redux
    const { 
        organizations, 
        unselected_organization_ids, 
        unselected_workspace_ids 
    } = useSelector(state => state.notification_filter);

    // Functions
    const handleToggle = (isOpen) => {
        if (!isOpen) {
            setOpenId(null);

            // Trigger a re-fetch of notifications based on the new filters
        }
    };

    const isSelected = (item, type = '') => {
        if(type === 'organization') {
            return !unselected_organization_ids.includes(item.id);
        } else if(type === 'workspace') {
            if(unselected_organization_ids.includes(item.organization_id)) { return false; }
            return !unselected_workspace_ids.includes(item.id);
        }

        return true;
    }

    const handleWorkspaceToggle = (e, workspace) => {
        e.preventDefault();
        e.stopPropagation();

        dispatch({ type: notificationFilterConstants.TOGGLE_UNSELECTED_WORKSPACE, payload: workspace });
    }

     const handleToggleOrg = (e, organization) => {
        e.preventDefault();
        e.stopPropagation();

        dispatch({ type: notificationFilterConstants.TOGGLE_UNSELECTED_ORGANIZATION, payload: organization });
    }

    const handleClearFilters = () => {
        dispatch({ type: notificationFilterConstants.RESET_ORGANIZATION_AND_WORKSPACE_FILTERS });
    }

    // Variables
    const hasNoUnselected = unselected_organization_ids?.length === 0 && unselected_workspace_ids?.length === 0;
    const workspaces = organizations?.flatMap(org => org.workspaces) || [];
    const selectedWorkspaces = workspaces?.filter(ws => !unselected_workspace_ids?.includes(ws.id) && !unselected_organization_ids?.includes(ws.organization_id));

    return (
        <div 
            className="d-flex align-items-center notifications--notification-list--workspace-dropdown-container workspace-filter"
        >  
            {
                hasNoUnselected ? null : (
                    <Button 
                        variant="link" 
                        className="notifications--notification-list--clear-btn"
                        onClick={handleClearFilters}
                    >
                        Clear
                    </Button>
                )
            }

            <Dropdown
                onToggle={handleToggle}
                className={'notifications--notification-list--workspace-dropdown'}
            >
                <Dropdown.Toggle 
                    variant={ hasNoUnselected ? "outline-gray" : "orange" }
                    size={'sm'}
                    className={hasNoUnselected ? '' : 'fw-500'}
                >
                    <div className="d-flex align-items-center justify-content-between">
                        {
                            hasNoUnselected ? (
                                <span>Select Workspace</span>
                            ) : (
                                <>
                                    <span>Selected Workspaces</span>
                                    <div className="workspace-count d-flex align-items-center justify-content-center">{selectedWorkspaces.length}</div> 
                                </>
                            )
                        }
                    
                    </div>

                    <DropdownDownIcon height={'8'} width={'8'} className="dropdown-icon" { ...(hasNoUnselected ?  {  } : {color: 'white'}) }/>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    {
                        organizations?.map((item) => (
                            <SubMenuItem 
                                key={item.id}
                                item={item}
                                openId={openId}
                                setOpenId={setOpenId}
                                isSelected={isSelected}
                                handleWorkspaceToggle={handleWorkspaceToggle}
                                handleToggleOrg={handleToggleOrg}
                                unselected_workspace_ids={unselected_workspace_ids}
                            />
                        ))
                    }
                </Dropdown.Menu>
            </Dropdown>
        </div>
    )
}

export default NotificationWorkspaceDropdown;